// Modules
import cn from 'classnames'

// Types
import type { HTMLAttributes } from 'react';
import type { TDividerType } from './Divider.type';

// Constants
import { DIVIDER_DEFAULT_PROPS } from './Divider.constant';

// Styles
import styles from './styles.module.scss';

export type TDividerProps = {
  /** Set the Divider's type. It will affect the Divider's position */
  type?: TDividerType;
} & HTMLAttributes<HTMLDivElement>;

const Divider = (props: TDividerProps) => {
  const {
    children,
    className,
    type = DIVIDER_DEFAULT_PROPS.type || 'center',
    ...restProps
  } = props;

  const dividerCN = cn(styles.legion_divider, className,
    children ? styles[type!] : styles.no_text
  );

  return (
    <div className={dividerCN} {...restProps}>
      {children ? (
        <span className={styles.text}>{children}</span>
      ) : (
        <hr className={styles.hr} />
      )}
    </div>
  );
}

export default Divider;
